import { BpAnchor } from '../../../../shared/components/text/anchor/BpAnchor'
import { Tooltip } from '../../../../shared/components/text/tooltip/Tooltip'
import React from 'react'

interface PageCellWithAutoProps {
  url: string
  is_auto?: boolean
}

export const PageCellWithAuto = ({ url, is_auto }: PageCellWithAutoProps) => {
  return (
    <div className={'flex items-center gap-[8px]'}>
      <div className='max-w-[300px] truncate'>
        <Tooltip title={url}>
          <BpAnchor href={url} target='_blank'>
            {url.replace(/^(http:\/\/|https:\/\/)?(www\.)?/, '')}
          </BpAnchor>
        </Tooltip>
      </div>
      {is_auto && (
        <span
          className={
            'flex h-[16px] items-center rounded-[2px] border-[1px] border-[#4DB11E] px-[4px] text-[9px] uppercase text-[#4DB11E]'
          }
        >
          Auto
        </span>
      )}
    </div>
  )
}
